import React, { useState } from 'react'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuBar from './CustomMenuBar'
import MainEdit from './EditUserDetailsAllApplications/Main'
import ScoringPopupviewMain from "../../CreditModule/scoring/ScoringViewPopup/Main"
import { deleteUserRoleByIdType } from '../../AdminActionCreator.component';
import Loader from '../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../presentationals/Popup/Popup.component'
export default function TabBox({ viewIngData, handleSubViewtype, subViewType, admin, viewType, handlecheckborrowerApi,PayloadBorrowerId }) {
    const [loader, setLoader] = useState(false)
    const [popup, setpopup] = useState({ show: false, popupStatus: "" })
    const [ViewData, setViewData] = useState({})
    const [anslysisPopup, setAnalysisPopup] = useState({ show: false, data: {} })

    const onViewDetails = (data) => {
        setViewData(data)
        setTimeout(() => {
            handleSubViewtype("details")
        }, 100)
    }
    const onViewanalysis = (data) => {
        console.log("data", data)
        const obj = {
            userId: data?.userId,
            firstName: data?.name,
            lastName: data?.lastName,
        }
        handleInternalScoringPopup(true, obj)

    }

    const handleInternalScoringPopup = (type, value) => {
        setAnalysisPopup({ show: type, data: value })
    }

    const handleDelete = (data) => {
        setLoader(true)
        const type = viewType == "coBorrower" ? "CoBorrower" : viewType == "gaurantor" ?  "Guarantor" : ""
        deleteUserRoleByIdType(data?.userId, type, callback => {
            setLoader(false)
            handlecheckborrowerApi()
            setpopup({ show: true, popupStatus: `${type} Deleted Successfully` })
            setTimeout(() => {
                closePopup()
            }, 5000)
        })
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: '' })
    }

    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
            }
            {
                subViewType == "list" ?

                    <div className="container-fluid">
                        <div className="row" style={{ marginTop: '30px' }}>
                            {
                                viewIngData && viewIngData?.length > 0 ?
                                    viewIngData?.map((value, index) => {
                                        return (
                                            <div className="col-sm-4 col-xs-12" key={index}>
                                                <div className="customcardBoxShadowHoverEffect" style={{ marginTop: '20px', padding: '15px', borderRadius: '6px', boxShadow: 'rgb(238, 238, 238) 3px 3px 10px 1px' }}>
                                                    <div className='row'>
                                                        <div className='col-lg-2 col-xs-3  text-center'>
                                                            <AccountCircleIcon style={{ color: "grey", width: '60px', height: '60px' }} />
                                                        </div>
                                                        <div className='col-lg-6 col-xs-5'>
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <h4 style={{ marginBottom: '0', fontSize: '32px' }}>{value?.name}</h4>
                                                                <h5 style={{ marginBottom: '0', background: value?.status == "ACTIVE" ? "#579a1d" : "red", color: "#fff", borderRadius: '6px', padding: '6px 10px', marginLeft: '20px' }}>{value?.status}</h5>
                                                            </div>
                                                        </div>
                                                        <div className="col-xs-2" style={{ float: 'right', textAlign: 'end' }}>
                                                            <MenuBar
                                                                onViewDetails={() => {
                                                                    onViewDetails(value)
                                                                }}
                                                                onViewanalysis={() => {
                                                                    onViewanalysis(value)
                                                                }}
                                                                onDelete={() => {
                                                                    handleDelete(value)
                                                                }}

                                                            />
                                                        </div>
                                                    </div>
                                                    <hr style={{ margin: '10px 0' }} />
                                                    <div>
                                                        <div className="row">
                                                            <div className="col-xs-5">
                                                                <h5 style={{ color: '#aba6a6' }}>Email:</h5>
                                                            </div>
                                                            <div className="col-xs-7">
                                                                <h5 style={{ textAlign: "end", wordBreak: 'break-all' }}>{value?.emailId || ""}</h5>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-xs-5">
                                                                <h5 style={{ color: '#aba6a6' }}>Mobile Number:</h5>
                                                            </div>
                                                            <div className="col-xs-7">
                                                                <h5 style={{ textAlign: "end", wordBreak: 'break-all' }}>{value?.mobileNo || ""}</h5>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-xs-5">
                                                                <h5 style={{ color: '#aba6a6' }}>AMU Decision:</h5>
                                                            </div>
                                                            <div className="col-xs-7">
                                                                <h5 style={{ textAlign: "end", wordBreak: 'break-all' }}>{value?.amuDecision || ""}</h5>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-xs-5">
                                                                <h5 style={{ color: '#aba6a6' }}>CRIF Decision:</h5>
                                                            </div>
                                                            <div className="col-xs-7">
                                                                <h5 style={{ textAlign: "end", wordBreak: 'break-all' }}>{value?.crifDecision || ""}</h5>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-xs-5">
                                                                <h5 style={{ color: '#aba6a6' }}>Form Status:</h5>
                                                            </div>
                                                            <div className="col-xs-7">
                                                                <h5 style={{ textAlign: "end", wordBreak: 'break-all' }}>{value?.formStatus || ""}</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                    : ''}
                        </div>

                        {
                            anslysisPopup?.show ?
                                <ScoringPopupviewMain type={"coborrower"} LeadData={anslysisPopup.data} closePopupbtn={handleInternalScoringPopup} admin={admin} />
                                : ''}

                    </div>
                    : ''}

            {subViewType == "details" ?
                <MainEdit userDetails={ViewData} viewType={viewType} admin={admin}  PayloadBorrowerId={ViewData?.userId} />
                : ''}
        </>
    )
}
